export default {
  'productLibrary.tab.merchantTypes': 'Merchant types',
  'productLibrary.tab.groups': 'Product groups',
  'productLibrary.tab.sharedProducts': 'Shared products',
  'productLibrary.field.code': 'Code',
  'productLibrary.field.name': 'Name',
  'productLibrary.field.standardName': 'Standard name',
  'productLibrary.field.unit': 'Unit',
  'productLibrary.field.invoiceItemType': 'Invoice item type',
  'productLibrary.field.recommendedTax': 'Recommended tax',
  'productLibrary.field.status': 'Status',
  'productLibrary.field.sortOrder': 'Order',
  'productLibrary.field.productGroups': 'Product groups',
  'productLibrary.field.productCount': 'Products',
  'productLibrary.status.active': 'Active',
  'productLibrary.status.inactive': 'Inactive',
  'productLibrary.action.edit': 'Edit',
  'productLibrary.action.remove': 'Remove',
  'productLibrary.action.addMerchantType': 'Add merchant type',
  'productLibrary.action.addGroup': 'Add group',
  'productLibrary.action.addProduct': 'Add product',
  'productLibrary.action.groupProducts': 'Group products',
  'productLibrary.title.editMerchantType': 'Edit merchant type',
  'productLibrary.title.addMerchantType': 'Add merchant type',
  'productLibrary.title.editGroup': 'Edit product group',
  'productLibrary.title.addGroup': 'Add product group',
  'productLibrary.title.editProduct': 'Edit product',
  'productLibrary.title.addProduct': 'Add shared product',
  'productLibrary.toast.memberAdded': 'Product added to group',
  'productLibrary.toast.memberRemoved': 'Product removed from group',
  'productLibrary.toast.imported': 'Import successful',
  'productLibrary.toast.saved': 'Saved',
  'productLibrary.csv.invalidTitle': 'Invalid CSV',
  'productLibrary.csv.row': 'Row',
  'productLibrary.csv.rows': 'rows',
  'productLibrary.csv.validPreview':
    'The dry-run is valid. The commit is atomic.',
  'productLibrary.action.importMembership': 'Import product groups',
  'productLibrary.action.exportMembership': 'Export product groups',
  'productLibrary.action.addToGroup': 'Add to group',
  'productLibrary.drawer.groupProducts': 'Group products',
  'productLibrary.drawer.help':
    'Search the shared catalog to add products. The table below is paginated; use CSV import for large catalogs.',
  'productLibrary.drawer.searchProducts':
    'Search shared products by code or name',
  'productLibrary.drawer.searching': 'Searching…',
  'productLibrary.drawer.searchHint': 'Type to search products',
  'productLibrary.drawer.filterProducts': 'Filter products in this group',
  'productLibrary.form.merchantTypeGroupsHelp':
    'Merchants assigned this type can access products in these groups.',
  'productLibrary.form.selectGroups': 'Select one or more product groups',
  'productLibrary.form.parentGroup': 'Parent group',
  'productLibrary.form.groupHelp':
    'Manage products with the Group products action, or import memberships from CSV.',
  'productLibrary.form.belongsToGroups': 'Product groups',
  'productLibrary.form.productGroupsHelp':
    'Assign to product groups, or import memberships from CSV for large catalogs.',
  'csvImport.action.import': 'Import',
  'csvImport.action.downloadTemplate': 'Download CSV template',
  'csvImport.action.selectFile': 'Select CSV file',
  'pages.layouts.userLayout.title': 'Secure access to your financial dashboard',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'ra.auth.sign_in': 'Sign in',
  'ra.auth.username': 'Username',
  'ra.auth.password': 'Password',
  'text.forgotPassword': 'Forgot password?',
  'text.enterOtp': 'Please enter your 2FA code',
  'text.verifyOtp': 'Verify OTP',
  'text.welcome': 'Welcome, {name}',
  'text.back': 'Back',
  'text.otp': 'OTP code (6 digits)',
  'text.otpRequired': 'Enter OTP',
  'text.otpLen': 'OTP must be 6 digits',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'text.invalidCredential': 'Invalid username or password',
  'text.loginSuccess': 'Login success',
  'text.otpFailed': 'OTP verification failed',
  'text.user': 'User',
  'common.validation.maxChars': 'Max {max} chars',
  'common.validation.minChars': 'Min {min} chars',
  'app.sessionExpired': 'Session expired. Please sign in again.',
  'error.userPasswordReused':
    'Password must not match one of the recent 24 passwords',
  'auth.password.required.new': 'New password is required',
  'auth.password.required.confirm': 'Confirm password is required',
  'auth.password.rule':
    'Password must be 16-65 chars and include letter, number, and special character.',
  'auth.password.mismatch': 'Passwords do not match',
  'auth.otp.label': 'OTP',
  'auth.otp.required': 'OTP is required',
  'auth.otp.length': 'OTP must be 6 digits',
  'auth.otp.placeholder': 'OTP code (6 digits)',
  'auth.email.required': 'Email is required',
  'auth.email.invalid': 'Invalid email format',
  'auth.backToLogin': 'Back to login',
  'setup.title': 'Bootstrap Admin',
  'setup.subtitle.token': 'Validate bootstrap access.',
  'setup.subtitle.admin': 'Admin account',
  'setup.error.unavailable':
    'Bootstrap is not available because an activated admin already exists.',
  'setup.error.checkFailed': 'Bootstrap token check failed',
  'setup.error.initFailed': 'Admin bootstrap failed',
  'setup.form.token': 'Bootstrap token',
  'setup.form.token.required': 'Bootstrap token is required',
  'setup.form.login': 'Login',
  'setup.form.firstName': 'First name',
  'setup.form.lastName': 'Last name',
  'setup.form.language': 'Language',
  'setup.button.continue': 'Continue',
  'setup.button.sendActivation': 'Send activation email',
  'setup.status.expiresAt': 'Token expires at',
  'setup.notice.sent': 'Activation email sent',
  'forget.title': 'Forgot Password',
  'forget.subtitle': 'Enter your account email to receive a reset link.',
  'forget.notice.generic':
    'If an account exists for this email address, password reset instructions will be sent.',
  'forget.button.send': 'Send reset link',
  'reset.title': 'Reset Password',
  'reset.subtitle': 'Set a new password for your account.',
  'reset.error.missingKey':
    'Reset key is missing. Please use the password-reset link from your email.',
  'reset.error.failed': 'Failed to reset password',
  'reset.button.submit': 'Reset password',
  'reset.success':
    'Password reset successful. You can now sign in with your new password.',
  'activate.title': 'Activate Account',
  'activate.subtitle.setPassword':
    'Set your account password to continue activation.',
  'activate.subtitle.verifyOtp':
    'Scan authenticator setup and verify your OTP.',
  'activate.subtitle.done': 'Your account is activated and 2FA is configured.',
  'activate.error.missingKey':
    'Activation key is missing. Please use the activation link from your email.',
  'activate.error.failed': 'Activation failed',
  'activate.error.otpFailed': 'OTP verification failed',
  'activate.qr.unavailable':
    'Authenticator setup URL is unavailable. Please contact support.',
  'activate.qr.copyCode': 'Copy',
  'activate.button.submit': 'Activate account',
  'activate.button.verify': 'Verify and finish',
  'activate.done.success':
    'Activation completed successfully. You can now sign in.',
  'passwordExpired.title': 'Password Expired',
  'passwordExpired.subtitle':
    'Update your password to continue. A valid OTP is required.',
  'passwordExpired.error.missingEmail': 'Email is missing. Please retry login.',
  'passwordExpired.error.failed': 'Failed to update password',
  'passwordExpired.error.tokenMissing':
    'Password changed but sign-in token is missing',
  'passwordExpired.form.email': 'Email',
  'passwordExpired.form.currentPassword': 'Current password',
  'passwordExpired.button.submit': 'Update password',
  'account.settings.title': 'Account Settings',
  'account.settings.subtitle':
    'Update your profile information and security credentials.',
  'account.profile.cardTitle': 'Profile',
  'account.profile.firstName': 'First name',
  'account.profile.lastName': 'Last name',
  'account.profile.imageUrl': 'Avatar URL',
  'account.profile.lang': 'Language',
  'account.profile.lang.en': 'English',
  'account.profile.lang.vi': 'Tiếng Việt',
  'account.profile.button.save': 'Save profile',
  'account.profile.success': 'Profile updated successfully.',
  'account.profile.error.failed': 'Failed to update profile',
  'account.validation.firstNameRequired': 'First name is required',
  'account.validation.lastNameRequired': 'Last name is required',
  'account.security.cardTitle': 'Security',
  'account.security.currentPassword': 'Current password',
  'account.security.newPassword': 'New password',
  'account.security.confirmPassword': 'Confirm new password',
  'account.security.button.change': 'Change password',
  'account.security.success': 'Password updated successfully.',
  'account.security.error.failed': 'Failed to update password',
  'account.validation.currentPasswordRequired': 'Current password is required',
  'account.center.title': 'Account Center',
  'account.center.subtitle': 'View your profile summary and security status.',
  'account.center.profile.title': 'Profile Overview',
  'account.center.security.title': 'Security Status',
  'account.center.button.openSettings': 'Open settings',
  'account.center.field.fullName': 'Full name',
  'account.center.field.login': 'Login',
  'account.center.field.email': 'Email',
  'account.center.field.language': 'Language',
  'account.center.field.avatarUrl': 'Avatar URL',
  'account.center.field.activated': 'Activated',
  'account.center.field.twofa': '2FA',
  'account.center.field.lastModified': 'Last modified',
  'account.center.field.created': 'Created',
  'account.center.value.yes': 'Yes',
  'account.center.value.no': 'No',
  'account.center.value.twofaEnabledAfterActivation':
    'Enabled after activation',
  'account.center.error.loadFailed': 'Failed to load account information',
  'admin.common.search': 'Search',
  'admin.common.actions': 'Actions',
  'admin.common.edit': 'Edit',
  'admin.common.delete': 'Delete',
  'admin.common.yes': 'Yes',
  'admin.common.no': 'No',
  'admin.common.save': 'Save',
  'admin.common.reset': 'Reset',
  'admin.common.saved': 'Saved',
  'admin.common.saveFailed': 'Save failed',
  'admin.users.title': 'Users',
  'admin.users.action.create': 'Create User',
  'admin.users.action.resendActivation': 'Resend activation',
  'admin.users.action.forgotPassword': 'Forgot password',
  'admin.users.field.login': 'Login',
  'admin.users.field.firstName': 'First Name',
  'admin.users.field.lastName': 'Last Name',
  'admin.users.field.activated': 'Activated',
  'admin.users.field.roles': 'Roles',
  'admin.users.confirm.delete': 'Delete this user?',
  'admin.users.modal.createTitle': 'Create User',
  'admin.users.modal.editTitle': 'Edit User',
  'admin.users.toast.loadUserFailed': 'Failed to load user',
  'admin.users.toast.created': 'User created',
  'admin.users.toast.updated': 'User updated',
  'admin.users.toast.deleted': 'User deleted',
  'admin.users.toast.deleteFailed': 'Failed to delete user',
  'admin.users.toast.resendActivationSuccess': 'Resent activation email',
  'admin.users.toast.resendActivationFailed':
    'Failed to resend activation email',
  'admin.users.toast.notEligibleReset':
    'User is not eligible for password reset',
  'admin.users.toast.sentForgotPassword': 'Sent forgot password email',
  'admin.users.toast.sendForgotPasswordFailed':
    'Failed to send forgot password email',
  'admin.roles.title': 'Roles',
  'admin.roles.field.name': 'Name',
  'admin.roles.field.active': 'Active',
  'admin.roles.action.add': 'Add Role',
  'admin.roles.action.addUser': 'Add user',
  'admin.roles.action.removeUser': 'Remove',
  'admin.roles.value.active': 'Active',
  'admin.roles.value.disabled': 'Disabled',
  'admin.roles.modal.createTitle': 'Create role',
  'admin.roles.modal.editTitle': 'Edit role',
  'admin.roles.validation.nameRequired': 'Name is required',
  'admin.roles.detail.title': 'Role detail',
  'admin.roles.detail.selectHint': 'Select a role to view details',
  'admin.roles.detail.loading': 'Loading role...',
  'admin.roles.detail.notFound': 'Role not found',
  'admin.roles.detail.roleName': 'Role: {name}',
  'admin.roles.permissions.title': 'Permissions',
  'admin.roles.permissions.selectAllSubMenus': 'Select all submenus',
  'admin.roles.permissions.selectPlaceholder': 'Select permissions...',
  'admin.roles.permissions.selectAll': 'Select All',
  'admin.roles.permissions.loadFailed': 'Failed to load permissions',
  'admin.roles.placeholder.searchUser': 'Search user...',
  'admin.roles.toast.created': 'Role created',
  'admin.roles.toast.updated': 'Role updated',
  'admin.roles.toast.loadFailed': 'Failed to load roles',
  'admin.roles.toast.userAdded': 'Added',
  'admin.roles.toast.userAddFailed': 'Add failed',
  'admin.roles.toast.userRemoved': 'Removed',
  'admin.roles.toast.userRemoveFailed': 'Remove failed',
  'admin.roles.toast.activated': 'Role activated',
  'admin.roles.toast.disabled': 'Role disabled',
  'admin.roles.toast.changeStatusFailed': 'Failed to change role status',
  'branches.title': 'Branches',
  'branches.field.name': 'Name',
  'branches.field.code': 'Code',
  'branches.field.parent': 'Parent branch',
  'branches.field.address': 'Address',
  'branches.field.phone': 'Phone',
  'branches.field.level': 'Level',
  'branches.action.add': 'Add',
  'branches.action.activate': 'Activate',
  'branches.action.disable': 'Disable',
  'branches.value.active': 'Active',
  'branches.value.disabled': 'Disabled',
  'branches.empty.select': 'Select a branch',
  'branches.placeholder.search': 'Search branches...',
  'branches.placeholder.root': 'Root (no parent)',
  'branches.modal.createTitle': 'Create branch',
  'branches.modal.editTitle': 'Edit branch',
  'branches.validation.nameRequired': 'Name is required',
  'branches.confirm.activateTitle': 'Activate branch?',
  'branches.confirm.activateContent':
    'Are you sure you want to activate "{name}"?',
  'branches.confirm.disableTitle': 'Disable branch?',
  'branches.confirm.disableContent':
    'Are you sure you want to disable "{name}"?',
  'branches.confirm.deleteTitle': 'Delete branch?',
  'branches.confirm.deleteContent':
    'Are you sure you want to delete "{name}"? This action cannot be undone.',
  'branches.toast.loadFailed': 'Failed to load branches',
  'branches.toast.created': 'Branch created',
  'branches.toast.updated': 'Branch updated',
  'branches.toast.deleted': 'Branch deleted',
  'branches.toast.activated': 'Branch activated',
  'branches.toast.disabled': 'Branch disabled',
  'merchants.title': 'Merchants',
  'merchants.field.branch': 'Branch',
  'merchants.field.legalName': 'Legal Name',
  'merchants.field.status': 'Status',
  'merchants.field.city': 'City',
  'merchants.field.state': 'State',
  'merchants.field.zipCode': 'Zip Code',
  'merchants.field.industryCode': 'Industry Code',
  'merchants.field.categoryCode': 'Category Code',
  'merchants.field.supportPhone': 'Support Phone',
  'merchants.field.loyalty': 'Loyalty',
  'merchants.field.loyaltyEnabled': 'Loyalty enabled',
  'merchants.field.loyaltyEarnRatePercent': 'Loyalty earn rate card (%)',
  'merchants.field.loyaltyEarnRatePercentCash': 'Loyalty earn rate cash (%)',
  'merchants.field.loyaltyEarnRatePercentQr': 'Loyalty earn rate QR (%)',
  'merchants.field.maxAmountPerTransaction': 'Max amount per transaction',
  'merchants.field.maxTotalAmountPerDay': 'Max total amount per day',
  'merchants.field.maxTotalAmountPerMonth': 'Max total amount per month',
  'merchants.action.create': 'Create Merchant',
  'merchants.action.activate': 'Activate',
  'merchants.action.disable': 'Disable',
  'merchants.value.active': 'Active',
  'merchants.value.disabled': 'Disabled',
  'merchants.placeholder.selectBranch': 'Select branch',
  'merchants.placeholder.allBranches': 'All branches',
  'merchants.modal.createTitle': 'Create merchant',
  'merchants.modal.editTitle': 'Edit merchant',
  'merchants.validation.legalNameRequired': 'Legal name is required',
  'merchants.validation.loyaltyEarnRateRequired':
    'Loyalty earn rate card is required',
  'merchants.validation.loyaltyEarnRateCashRequired':
    'Loyalty earn rate cash is required',
  'merchants.validation.loyaltyEarnRateQrRequired':
    'Loyalty earn rate QR is required',
  'merchants.confirm.activateTitle': 'Activate merchant?',
  'merchants.confirm.activateContent':
    'Are you sure you want to activate "{name}"?',
  'merchants.confirm.disableTitle': 'Disable merchant?',
  'merchants.confirm.disableContent':
    'Are you sure you want to disable "{name}"?',
  'merchants.confirm.deleteTitle': 'Delete merchant?',
  'merchants.confirm.deleteContent':
    'Are you sure you want to delete "{name}"?',
  'merchants.toast.loadFailed': 'Failed to load merchant',
  'merchants.toast.created': 'Merchant created',
  'merchants.toast.updated': 'Merchant updated',
  'merchants.toast.deleted': 'Merchant deleted',
  'merchants.toast.deleteFailed': 'Failed to delete merchant',
  'merchants.toast.activated': 'Merchant activated',
  'merchants.toast.disabled': 'Merchant disabled',
  'merchants.toast.changeStatusFailed': 'Failed to change status',
  'merchants.action.einvoice': 'E-Invoice',
  'merchants.modal.einvoiceTitle': 'E-Invoice configuration',
  'merchants.field.taxCode': 'Tax code (MST)',
  'merchants.field.einvoiceProvider': 'E-invoice provider',
  'merchants.field.einvoiceConnector': 'Connector',
  'merchants.field.einvoiceTemplate': 'Invoice template',
  'merchants.field.einvoiceSerial': 'Invoice serial',
  'merchants.einvoice.taxCodeHint':
    'Seller tax code — required for orders to be eligible for e-invoice issuance',
  'merchants.validation.taxCodeRequired': 'Tax code is required',
  'merchants.validation.taxCodeFormat':
    '8-20 characters: letters, digits or dash',
  'merchants.toast.einvoiceConfigured': 'E-Invoice config updated',
  'einvoices.title': 'E-Invoice Management',
  'einvoices.remediation.title': 'Requires Attention',
  'einvoices.field.createdDate': 'Created at',
  'einvoices.field.merchant': 'Merchant',
  'einvoices.field.merchantSearch': 'Merchant name or code…',
  'einvoices.field.transactionId': 'Transaction ID',
  'einvoices.field.transactionIdSearch': 'Transaction ID…',
  'einvoices.field.invoiceNo': 'Invoice number',
  'einvoices.field.invoiceNoSearch': 'Invoice number…',
  'einvoices.field.serial': 'Serial',
  'einvoices.field.status': 'Status',
  'einvoices.field.taxStatus': 'Tax authority status',
  'einvoices.field.totalAmount': 'Total amount',
  'einvoices.field.reasonCode': 'Reason code',
  'einvoices.field.note': 'Note',
  'einvoices.field.notePlaceholder': 'Add a processing note',
  'einvoices.filter.dateRange': 'Date range',
  'einvoices.filter.fromDate': 'From date',
  'einvoices.filter.toDate': 'To date',
  'einvoices.filter.statuses': 'Status',
  'einvoices.filter.statusesPlaceholder': 'Select status',
  'einvoices.filter.taxStatuses': 'Tax authority status',
  'einvoices.filter.taxStatusesPlaceholder': 'Select tax authority status',
  'einvoices.tab.invoices': 'Invoices',
  'einvoices.tab.remediations': 'Remediations',
  'einvoices.tab.test': 'Test',
  'einvoices.action.retry': 'Retry invoice issuance',
  'einvoices.action.suppress': 'Suppress entry',
  'einvoices.action.resolve': 'Resolved outside the system',
  'einvoices.remediation.status.open': 'Open',
  'einvoices.remediation.status.suppressed': 'Suppressed',
  'einvoices.remediation.status.resolved': 'Resolved',
  'einvoices.toast.updated': 'Updated',
  'einvoices.error.downloadPdf': 'Unable to download invoice PDF',
  'einvoices.error.viewPdf': 'Unable to preview invoice PDF',
  'einvoices.error.update': 'Unable to update entry',
  'einvoices.pdf.title': 'Invoice PDF',
  'partnerCredentials.title': 'Partner Credentials',
  'partnerCredentials.field.name': 'Name',
  'partnerCredentials.field.clientId': 'Client ID',
  'partnerCredentials.field.outboundClientId': 'Outbound Client ID',
  'partnerCredentials.field.inboundClientSecret': 'Inbound Client Secret',
  'partnerCredentials.field.outboundClientSecret': 'Outbound Client Secret',
  'partnerCredentials.field.inboundClientSecretInput':
    'Inbound Client Secret (optional)',
  'partnerCredentials.field.outboundClientSecretInput':
    'Outbound Client Secret (optional)',
  'partnerCredentials.placeholder.secretUnchanged':
    'Leave blank to keep the existing secret',
  'partnerCredentials.field.outboundUrl': 'Outbound URL',
  'partnerCredentials.field.inboundSignatureAlgorithm':
    'Inbound Signature Algorithm',
  'partnerCredentials.field.outboundSignatureAlgorithm':
    'Outbound Signature Algorithm',
  'partnerCredentials.field.status': 'Status',
  'partnerCredentials.action.create': 'Create',
  'partnerCredentials.value.active': 'Active',
  'partnerCredentials.value.disabled': 'Disabled',
  'partnerCredentials.modal.createTitle': 'Create partner credential',
  'partnerCredentials.modal.editTitle': 'Edit partner credential',
  'partnerCredentials.modal.createdTitle': 'Credentials generated',
  'partnerCredentials.modal.createdDescription':
    'These credentials are shown once and copied to your clipboard. Save them securely.',
  'partnerCredentials.modal.confirmSaved': 'OK, I have saved them',
  'partnerCredentials.validation.nameRequired': 'Name is required',
  'partnerCredentials.confirm.deleteTitle': 'Delete partner credential?',
  'partnerCredentials.confirm.deleteContent':
    'Are you sure you want to delete "{name}"?',
  'partnerCredentials.toast.created': 'Partner credential created',
  'partnerCredentials.toast.updated': 'Partner credential updated',
  'partnerCredentials.toast.deleted': 'Partner credential deleted',
  'loyalty.policy.title': 'Loyalty Policy',
  'loyalty.customer.detail.title': 'Customer loyalty details',
  'loyalty.customer.detail.rewards': 'Rewards by merchant',
  'loyalty.customer.detail.back': 'Back to customers',
  'loyalty.policy.version': 'Policy version',
  'loyalty.policy.text': 'Policy text',
  'loyalty.policy.active': 'Active',
  'loyalty.policy.effectiveFrom': 'Effective from',
  'loyalty.policy.publicUrl': 'Public URL',
  'loyalty.policy.action.create': 'Create Policy',
  'loyalty.policy.modal.createTitle': 'Create policy',
  'loyalty.policy.modal.editTitle': 'Edit policy',
  'loyalty.policy.preview': 'Preview',
  'loyalty.policy.updated': 'Policy updated',
  'loyalty.policy.validation.versionRequired': 'Policy version is required',
  'loyalty.policy.validation.textRequired': 'Policy text is required',
  'banks.title': 'Banks',
  'banks.field.code': 'Code',
  'banks.field.name': 'Name',
  'banks.field.host': 'Host',
  'banks.field.port': 'Port',
  'banks.field.timeoutMs': 'Timeout (ms)',
  'banks.field.status': 'Status',
  'banks.field.active': 'Active',
  'banks.action.create': 'Create Bank',
  'banks.action.activate': 'Activate',
  'banks.action.disable': 'Disable',
  'banks.value.active': 'Active',
  'banks.value.disabled': 'Disabled',
  'banks.modal.createTitle': 'Create bank',
  'banks.modal.editTitle': 'Edit bank',
  'banks.validation.codeRequired': 'Bank code is required',
  'banks.validation.nameRequired': 'Bank name is required',
  'banks.validation.hostRequired': 'Host is required',
  'banks.validation.portRequired': 'Port is required',
  'banks.validation.noCodeAvailable': 'All bank codes are already used.',
  'banks.confirm.activateTitle': 'Activate bank?',
  'banks.confirm.activateContent':
    'Are you sure you want to activate "{name}"?',
  'banks.confirm.disableTitle': 'Disable bank?',
  'banks.confirm.disableContent': 'Are you sure you want to disable "{name}"?',
  'banks.toast.created': 'Bank created',
  'banks.toast.updated': 'Bank updated',
  'banks.toast.activated': 'Bank activated',
  'banks.toast.disabled': 'Bank disabled',
  'dashboard.title': 'Dashboard',
  'dashboard.common.noData': 'No data',
  'dashboard.dateRange.today': 'Today',
  'dashboard.dateRange.thisWeek': 'This Week',
  'dashboard.dateRange.thisMonth': 'This Month',
  'dashboard.overview.totalMerchants': 'Total Merchants',
  'dashboard.overview.totalTerminals': 'Total Terminals',
  'dashboard.overview.transactions': 'Transactions',
  'dashboard.overview.totalAmount': 'Total Amount',
  'dashboard.overview.active': 'active',
  'dashboard.overview.inactive': 'inactive',
  'dashboard.overview.enrolled': 'enrolled',
  'dashboard.overview.activeCapitalized': 'Active',
  'dashboard.overview.inactiveCapitalized': 'Inactive',
  'dashboard.overview.enrolledCapitalized': 'Enrolled',
  'dashboard.overview.avg': 'Avg: {value}',
  'dashboard.overview.placeholder': 'placeholder',
  'dashboard.trend.title': 'Transaction Trend',
  'dashboard.trend.granularity.day': 'Day',
  'dashboard.trend.granularity.week': 'Week',
  'dashboard.trend.granularity.month': 'Month',
  'dashboard.trend.metric.count': 'Count',
  'dashboard.trend.metric.amount': 'Amount',
  'dashboard.trend.series.transactions': 'Transactions',
  'dashboard.trend.series.amount': 'Amount',
  'dashboard.distribution.byStatus': 'By Status',
  'dashboard.distribution.byPaymentType': 'By Payment Type',
  'dashboard.distribution.byTransactionType': 'By Transaction Type',
  'dashboard.status.merchantTitle': 'Merchant Status',
  'dashboard.status.terminalTitle': 'Terminal Status',
  'dashboard.topMerchants.title': 'Top Merchants by Volume',
  'transactions.title': 'Transactions',
  'transactions.page.title': 'Transaction Activity',
  'transactions.page.description':
    'Real-time transaction ledger entries and settlement logs',
  'transactions.tab.all': 'All',
  'transactions.tab.authorized': 'Authorized',
  'transactions.tab.settled': 'Settled',
  'transactions.tab.declined': 'Declined',
  'transactions.tab.error': 'Error',
  'transactions.tab.batchSummary': 'Batch Summaries',
  'transactions.batchList.title': 'Batches',
  'transactions.batchList.description':
    'Manage and reconcile transaction batches across connected terminals.',
  'transactions.batchList.statusTab.all': 'All Batches',
  'transactions.batchList.statusTab.open': 'Open',
  'transactions.batchList.statusTab.processing': 'Processing',
  'transactions.batchList.statusTab.settled': 'Settled',
  'transactions.field.transactionNo': 'Transaction ID',
  'transactions.field.batchId': 'Batch ID',
  'transactions.field.batchNumber': 'Batch No',
  'transactions.field.merchant': 'Merchant',
  'transactions.field.terminal': 'Terminal',
  'transactions.field.epi': 'EPI',
  'transactions.field.authCode': 'Auth Code',
  'transactions.field.cardNumber': 'Card Number',
  'transactions.field.customerName': 'Cardholder Name',
  'transactions.field.amount': 'Amount',
  'transactions.field.redeemedPoints': 'Redeemed Points',
  'transactions.field.paymentType': 'Payment Type',
  'transactions.field.transactionType': 'Transaction Type',
  'transactions.field.status': 'Status',
  'transactions.field.responseCode': 'Response Code',
  'transactions.field.processorResponse': 'Processor Response',
  'transactions.field.actions': 'Actions',
  'transactions.field.transactionDate': 'Transaction Date',
  'transactions.field.batchDate': 'Batch Date',
  'transactions.field.settledDate': 'Settled Date',
  'transactions.field.batchStatus': 'Batch Status',
  'transactions.field.paymentCount': 'Payment count',
  'transactions.field.grossSales': 'Gross Sales',
  'transactions.field.settledCount': 'Settled count',
  'transactions.field.settledAmount': 'Settled Amount',
  'transactions.field.currentBatch': 'Current Batch',
  'transactions.field.processor': 'Processor',
  'transactions.field.transactionTime': 'Time',
  'transactions.field.transactionDatePreset': 'Transaction Date',
  'transactions.field.transactionDateCustom': 'Transaction Date Custom',
  'transactions.field.fromDate': 'From Date',
  'transactions.field.toDate': 'To Date',
  'transactions.field.fromAmount': 'From Amount',
  'transactions.field.toAmount': 'To Amount',
  'transactions.placeholder.fromAmount': 'Min amount',
  'transactions.placeholder.toAmount': 'Max amount',
  'transactions.placeholder.selectTerminal': 'Select terminal',
  'transactions.placeholder.selectMerchant': 'Select merchant',
  'transactions.placeholder.searchMerchant': 'Search merchant',
  'transactions.placeholder.searchTerminal': 'Search terminal',
  'transactions.placeholder.searchTransactionId': 'Search transaction id',
  'transactions.placeholder.searchAuthCode': 'Search auth code',
  'transactions.placeholder.searchCardNumber': 'Search card number',
  'transactions.placeholder.searchCustomerName': 'Search cardholder name',
  'transactions.placeholder.searchStatus': 'Search status...',
  'transactions.placeholder.searchPaymentType': 'Search payment type...',
  'transactions.placeholder.searchTransactionType':
    'Search transaction type...',
  'transactions.placeholder.searchBatchId': 'Search batch id',
  'transactions.placeholder.searchBatchNumber': 'Search batch no',
  'transactions.placeholder.searchBatchStatus': 'Search batch status...',
  'transactions.placeholder.selectProcessor': 'Select processor',
  'transactions.empty.noTerminal': 'No terminal found',
  'transactions.empty.noMerchant': 'No merchant found',
  'transactions.value.active': 'Active',
  'transactions.value.inactive': 'Inactive',
  'transactions.value.batchStatus.open': 'Open',
  'transactions.value.batchStatus.processing': 'Processing',
  'transactions.value.batchStatus.settled': 'Settled',
  'transactions.value.batchStatus.paused': 'Paused',
  'transactions.preset.custom': 'Transaction Date Custom',
  'transactions.preset.past365Days': 'Past 365 Days',
  'transactions.preset.past180Days': 'Past 180 Days',
  'transactions.preset.past90Days': 'Past 90 Days',
  'transactions.preset.past30Days': 'Past 30 Days',
  'transactions.preset.past7Days': 'Past 7 Days',
  'transactions.preset.past3Days': 'Past 3 Days',
  'transactions.preset.lastYear': 'Last Year',
  'transactions.preset.lastQuarter': 'Last Quarter',
  'transactions.preset.lastMonth': 'Last Month',
  'transactions.preset.lastWeek': 'Last Week',
  'transactions.preset.yesterday': 'Yesterday',
  'transactions.preset.thisYear': 'This Year',
  'transactions.preset.thisQuarter': 'This Quarter',
  'transactions.preset.thisMonth': 'This Month',
  'transactions.preset.thisWeek': 'This Week',
  'transactions.preset.today': 'Today',
  'transactions.action.view': 'View',
  'transactions.action.cancel': 'Cancel',
  'transactions.action.apply': 'Apply',
  'transactions.receipt.action.view': 'View receipt',
  'transactions.receipt.action.download': 'Download receipt',
  'transactions.receipt.action.sendEmail': 'Send receipt email',
  'transactions.receipt.previewModal.title': 'Receipt',
  'transactions.receipt.public.title': 'Payment receipt',
  'transactions.receipt.public.merchantFallback': 'Payment Hub',
  'transactions.receipt.public.amount': 'Amount',
  'transactions.receipt.public.transactionTime': 'Transaction time',
  'transactions.receipt.public.preparing': 'Receipt is being prepared',
  'transactions.receipt.public.preparingDesc':
    'Please check this link again after the receipt is available.',
  'transactions.receipt.public.notFound': 'Receipt not found',
  'transactions.receipt.public.notFoundDesc':
    'Receipt link is invalid or expired.',
  'transactions.receipt.public.download': 'Download receipt',
  'transactions.receipt.public.email': 'Email',
  'transactions.receipt.public.emailPlaceholder': 'example@email.com',
  'transactions.receipt.public.emailRequired': 'Enter an email address',
  'transactions.receipt.public.emailInvalid': 'Enter a valid email address',
  'transactions.receipt.public.sendEmail': 'Send receipt email',
  'transactions.receipt.public.emailSent': 'Receipt email sent',
  'transactions.receipt.public.emailFailed':
    'Cannot send receipt email. Please try again later.',
  'transactions.receipt.emailModal.title': 'Send receipt email',
  'transactions.receipt.emailModal.send': 'Send',
  'transactions.receipt.emailModal.recipients': 'Recipients',
  'transactions.receipt.emailModal.placeholder':
    'customer@example.com, second@example.com',
  'transactions.receipt.validation.emailRequired':
    'Enter at least one email address',
  'transactions.receipt.validation.emailInvalid': 'Enter valid email addresses',
  'transactions.receipt.toast.emailSent': 'Receipt email sent',
  'transactions.receipt.toast.emailFailed': 'Failed to send receipt email',
  'transactions.validation.amountRange':
    'Amount from must be less than amount to',
  'transactions.detail.title': 'Transaction Detail',
  'transactions.detail.notFound': 'Transaction not found',
  'transactions.detail.backToList': 'Back to transactions',
  'transactions.batchDetail.title': 'Batch Detail',
  'transactions.batchDetail.notFound': 'Batch not found',
  'transactions.batchDetail.backToList': 'Back to batch summaries',
  'transactions.batchDetail.section.batchOverview': 'Batch Overview',
  'transactions.batchDetail.section.processing': 'Processing Info',
  'transactions.batchDetail.section.settlementReconciliation':
    'Settlement Reconciliation',
  'transactions.batchDetail.relatedTransactions': 'Related Batch Transactions',
  'transactions.detail.action.return': 'Return',
  'transactions.detail.action.newSale': 'New Sale',
  'transactions.detail.action.newAuth': 'New Auth',
  'transactions.detail.action.download': 'Download',
  'transactions.detail.action.downloadCardHolderCopy': 'Card Holder Copy',
  'transactions.detail.action.downloadMerchantCopy': 'Merchant Copy',
  'transactions.detail.action.sendEmail': 'Send via Email',
  'transactions.detail.action.comingSoon': 'Coming soon',
  'transactions.detail.field.total': 'Total',
  'transactions.detail.field.totalTransactionValue': 'Total Transaction Value',
  'transactions.detail.field.approved': 'Approved',
  'transactions.detail.field.transactionType': 'Transaction Type',
  'transactions.detail.field.totalPurchaseAmount': 'Total Purchase Amount',
  'transactions.detail.field.subtotal': 'Subtotal',
  'transactions.detail.field.redeemedPoints': 'Redeemed Points',
  'transactions.detail.field.redeemAmount': 'Redeem Amount',
  'transactions.detail.field.loyaltyRewardBalance': 'Loyalty Balance',
  'transactions.detail.field.tip': 'Tip',
  'transactions.detail.field.tax': 'Tax',
  'transactions.detail.field.surcharge': 'Surcharge',
  'transactions.detail.field.discount': 'Discount',
  'transactions.detail.field.shipping': 'Shipping',
  'transactions.detail.field.transactionId': 'Transaction ID',
  'transactions.detail.field.createdAt': 'Created',
  'transactions.detail.section.transactionOverview': 'Transaction Overview',
  'transactions.detail.section.cardInfo': 'Credit Card Information',
  'transactions.detail.field.cardNumber': 'Card Number',
  'transactions.detail.field.cardExpiration': 'Card Expiration',
  'transactions.detail.field.cardType': 'Card Type',
  'transactions.detail.field.cvvStatus': 'CVV Status',
  'transactions.detail.field.authorizationCode': 'Authorization Code',
  'transactions.detail.field.avsStatus': 'AVS Status',
  'transactions.detail.field.entryMethod': 'Entry Method',
  'transactions.detail.field.responseCode': 'Response Code',
  'transactions.detail.field.processorResponse': 'Processor Response',
  'transactions.detail.field.settledOn': 'Settled on',
  'terminals.title': 'Terminals',
  'terminals.organization.title': 'Organization',
  'terminals.organization.createBranch': 'Create Branch',
  'terminals.organization.createMerchant': 'Create Merchant',
  'terminals.organization.searchPlaceholder': 'Search branch or merchant',
  'terminals.selection.selected': 'Selected:',
  'terminals.selection.branch': 'Branch: {name}',
  'terminals.selection.merchant': 'Merchant: {name}',
  'terminals.field.epi': 'EPI',
  'terminals.field.name': 'Name',
  'terminals.field.serial': 'Serial',
  'terminals.field.serialNumber': 'Serial Number',
  'terminals.field.merchant': 'Merchant',
  'terminals.field.branch': 'Branch',
  'terminals.field.status': 'Status',
  'terminals.field.enrolled': 'Enrolled',
  'terminals.field.deviceStatus': 'Device Status',
  'terminals.field.createdDate': 'Created Date',
  'terminals.field.partnerId': 'Partner ID',
  'terminals.field.loadDate': 'Load Date',
  'terminals.value.active': 'Active',
  'terminals.value.disabled': 'Disabled',
  'terminals.value.enrolled': 'Enrolled',
  'terminals.value.notEnrolled': 'Not Enrolled',
  'terminals.value.addedToFutureX': 'Added to FutureX',
  'terminals.action.view': 'View',
  'terminals.action.create': 'Create Terminal',
  'terminals.action.activate': 'Activate',
  'terminals.action.disable': 'Disable',
  'terminals.action.publicKey': 'Public Key',
  'terminals.action.reImport': 'Re-import',
  'terminals.action.clearLoadDate': 'Clear Load Date',
  'terminals.action.lockDevice': 'Lock Device',
  'terminals.action.unlockDevice': 'Unlock Device',
  'terminals.action.copy': 'Copy',
  'terminals.action.close': 'Close',
  'terminals.modal.createTitle': 'Create terminal',
  'terminals.modal.editTitle': 'Edit terminal',
  'terminals.warning.selectScopeFirst':
    'Please select a branch or merchant first',
  'terminals.validation.branchRequired': 'Branch is required',
  'terminals.validation.merchantRequired': 'Merchant is required',
  'terminals.validation.nameRequired': 'Name is required',
  'terminals.validation.serialLockedAfterEnrollment':
    'Cannot change serial number after enrollment',
  'terminals.confirm.activateTitle': 'Activate terminal?',
  'terminals.confirm.activateContent':
    'Are you sure you want to activate "{name}"?',
  'terminals.confirm.disableTitle': 'Disable terminal?',
  'terminals.confirm.disableContent':
    'Are you sure you want to disable "{name}"?',
  'terminals.confirm.deleteTitle': 'Delete terminal?',
  'terminals.confirm.deleteContent':
    'Are you sure you want to delete "{name}"?',
  'terminals.confirm.deleteContentWithUndo':
    'Are you sure you want to delete "{name}"? This action cannot be undone.',
  'terminals.toast.loadOrgFailed': 'Failed to load organization tree',
  'terminals.toast.loadFailed': 'Failed to load terminal',
  'terminals.toast.created': 'Terminal created',
  'terminals.toast.updated': 'Terminal updated',
  'terminals.toast.deleted': 'Terminal deleted',
  'terminals.toast.deleteFailed': 'Failed to delete terminal',
  'terminals.toast.activated': 'Terminal activated',
  'terminals.toast.disabled': 'Terminal disabled',
  'terminals.toast.changeStatusFailed': 'Failed to change status',
  'terminals.toast.copied': 'Copied',
  'terminals.employees.title': 'Employees',
  'terminals.employees.header': 'Merchant Employees',
  'terminals.employees.field.name': 'Name',
  'terminals.employees.field.role': 'Role',
  'terminals.employees.field.email': 'Email',
  'terminals.employees.field.phone': 'Phone',
  'terminals.employees.field.passcode': 'Passcode',
  'terminals.employees.value.activated': 'Activated',
  'terminals.employees.role.owner': 'Owner',
  'terminals.employees.role.manager': 'Manager',
  'terminals.employees.role.partner': 'Partner',
  'terminals.employees.role.staff': 'Staff',
  'terminals.employees.action.create': 'Create Employee',
  'terminals.employees.action.viewCode': 'View code',
  'terminals.employees.action.logs': 'Logs',
  'terminals.employees.confirm.deleteTitle': 'Delete employee?',
  'terminals.employees.confirm.deleteContent':
    'Are you sure you want to delete "{name}"?',
  'terminals.employees.modal.createTitle': 'Create employee',
  'terminals.employees.modal.editTitle': 'Edit employee',
  'terminals.employees.modal.activationCodeTitle': 'Activation code{suffix}',
  'terminals.employees.modal.activityLogsTitle': 'Activity logs{suffix}',
  'terminals.employees.validation.nameRequired': 'Name is required',
  'terminals.employees.validation.passcodeRequired': 'Passcode is required',
  'terminals.employees.validation.passcodeDigits':
    'Passcode must be exactly 4 digits',
  'terminals.employees.validation.roleRequired': 'Role is required',
  'terminals.employees.toast.loadFailed': 'Failed to load employee',
  'terminals.employees.toast.created': 'Employee created',
  'terminals.employees.toast.updated': 'Employee updated',
  'terminals.employees.toast.deleted': 'Employee deleted',
  'terminals.employees.toast.deleteFailed': 'Failed to delete employee',
  'terminals.employees.toast.loadActivationCodeFailed':
    'Failed to load activation code',
  'terminals.detail.notFound': 'Terminal not found',
  'terminals.detail.backToList': 'Back to terminals',
  'terminals.detail.tab.overview': 'Overview',
  'terminals.detail.tab.parameters': 'Parameters',
  'terminals.detail.tab.processors': 'Processors',
  'terminals.detail.tab.enrollments': 'Enrollments',
  'terminals.detail.tab.merchantActivityLogs': 'Merchant Activity Logs',
  'terminals.detail.publicKeyTitle': 'Terminal Public Key',
  'terminals.detail.confirm.addToFutureXTitle': 'Add terminal to FutureX?',
  'terminals.detail.confirm.addToFutureXContent':
    'Re-import terminal "{name}" to partner integration?',
  'terminals.detail.confirm.clearLoadDateTitle': 'Clear load date?',
  'terminals.detail.confirm.clearLoadDateContent':
    'Clear load date of terminal "{name}"?',
  'terminals.detail.confirm.lockTitle': 'Lock this device?',
  'terminals.detail.confirm.lockContent': 'Lock terminal "{name}" manually?',
  'terminals.detail.confirm.unlockTitle': 'Unlock this device?',
  'terminals.detail.confirm.unlockContent':
    'Unlock terminal "{name}" manually?',
  'terminals.detail.toast.actionFailed': 'Failed to execute action',
  'terminals.detail.toast.reImportRequested': 'Re-import request sent',
  'terminals.detail.toast.loadDateCleared': 'Load date cleared',
  'terminals.detail.toast.manualLockSent': 'Manual lock sent',
  'terminals.detail.toast.manualUnlockSent': 'Manual unlock sent',
  'terminals.logs.field.fromDate': 'From Date',
  'terminals.logs.field.toDate': 'To Date',
  'terminals.logs.field.employee': 'Employee',
  'terminals.logs.field.activity': 'Activity',
  'terminals.logs.field.logTime': 'Log Time',
  'terminals.logs.field.ipAddress': 'IP Address',
  'terminals.logs.placeholder.searchTerminal': 'Employee, activity, IP address',
  'terminals.logs.placeholder.searchEmployee': 'Activity, IP address',
  'terminals.snapshot.title': 'Latest Snapshot',
  'terminals.snapshot.field.snapshotAt': 'Snapshot At',
  'terminals.snapshot.field.cpuUsage': 'CPU Usage',
  'terminals.snapshot.field.ramUsage': 'RAM Usage',
  'terminals.snapshot.field.storageUsage': 'Storage Usage',
  'terminals.snapshot.field.batteryUsage': 'Battery Usage',
  'terminals.snapshot.field.androidVersion': 'Android Version',
  'terminals.snapshot.field.firmwareVersion': 'Firmware Version',
  'terminals.snapshot.field.ssid': 'SSID',
  'terminals.snapshot.field.latitude': 'Latitude',
  'terminals.snapshot.field.longitude': 'Longitude',
  'terminals.processors.modal.createTitle': 'Create processor',
  'terminals.processors.modal.editTitle': 'Edit processor',
  'terminals.processors.field.processor': 'Processor',
  'terminals.processors.field.mid': 'MID',
  'terminals.processors.field.tid': 'TID',
  'terminals.processors.field.devId': 'Dev ID',
  'terminals.processors.field.vNumber': 'V Number',
  'terminals.processors.field.bin': 'BIN',
  'terminals.processors.field.agent': 'Agent',
  'terminals.processors.field.chain': 'Chain',
  'terminals.processors.field.locationNumber': 'Location Number',
  'terminals.processors.field.store': 'Store',
  'terminals.processors.field.categoryCode': 'Category Code',
  'terminals.processors.field.default': 'Default',
  'terminals.processors.confirm.deleteTitle': 'Delete processor?',
  'terminals.processors.confirm.deleteContent':
    'Are you sure you want to delete "{name}"?',
  'terminals.processors.action.add': 'Add Processor',
  'terminals.processors.toast.created': 'Processor created',
  'terminals.processors.toast.updated': 'Processor updated',
  'terminals.processors.toast.deleted': 'Processor deleted',
  'terminals.enrollments.modal.createTitle': 'Create enrollment',
  'terminals.enrollments.modal.editTitle': 'Edit enrollment',
  'terminals.enrollments.field.activationCode': 'Activation Code',
  'terminals.enrollments.field.otpStart': 'OTP Start',
  'terminals.enrollments.field.otpEnd': 'OTP End',
  'terminals.enrollments.field.type': 'Type',
  'terminals.enrollments.modal.field.otpStartDate': 'OTP start date',
  'terminals.enrollments.modal.field.otpEndDate': 'OTP end date',
  'terminals.enrollments.field.used': 'Used',
  'terminals.enrollments.action.add': 'Add Enrollment',
  'terminals.enrollments.action.addAgent': 'Agent Enrollment',
  'terminals.enrollments.toast.created': 'Enrollment created',
  'terminals.enrollments.toast.agentCreated': 'Agent enrollment created',
  'terminals.enrollments.toast.updated': 'Enrollment updated',
  'terminals.enrollments.toast.deleted': 'Enrollment deleted',
  'terminals.parameters.section.dualPricing': 'Dual Pricing',
  'terminals.parameters.section.tip': 'Tip',
  'terminals.parameters.section.receipt': 'Receipt',
  'terminals.parameters.section.authorizationAndTax': 'Authorization and Tax',
  'terminals.parameters.section.otherOptions': 'Other Options',
  'terminals.parameters.field.enableDualPricing': 'Enable Dual Pricing',
  'terminals.parameters.field.enteredAmountMode': 'Entered Amount Mode',
  'terminals.parameters.field.cashDiscountPercentage':
    'Cash Discount Percentage',
  'terminals.parameters.field.enableTip': 'Enable Tip',
  'terminals.parameters.field.tipPercent1': 'Tip % 1',
  'terminals.parameters.field.tipPercent2': 'Tip % 2',
  'terminals.parameters.field.tipPercent3': 'Tip % 3',
  'terminals.parameters.field.tipPercent4': 'Tip % 4',
  'terminals.parameters.field.skipReceiptScreen': 'Skip Receipt Screen',
  'terminals.parameters.field.autoPrintCardHolderCopy':
    'Auto Print Card Holder Copy',
  'terminals.parameters.field.autoPrintMerchantCopy':
    'Auto Print Merchant Copy',
  'terminals.parameters.field.receiptFooter': 'Receipt Footer',
  'terminals.parameters.field.receiptDisclaimers': 'Receipt Disclaimers',
  'terminals.parameters.placeholder.disclaimerLine': 'Disclaimer line',
  'terminals.parameters.action.addDisclaimer': 'Add Disclaimer',
  'terminals.parameters.field.enableTax': 'Enable Tax',
  'terminals.parameters.field.salesTaxPercentage': 'Sales Tax Percentage',
  'terminals.parameters.field.enableTaxForCash': 'Enable Tax For Cash',
  'terminals.parameters.field.enableTaxForQr': 'Enable Tax For QR',
  'terminals.parameters.field.enableRemoveTax': 'Enable Remove Tax',
  'terminals.parameters.field.qrDiscountPercentage': 'QR Discount Percentage',
  'terminals.parameters.field.tipType': 'Tip Type',
  'terminals.parameters.field.tipAmount': 'Tip Amount {index}',
  'terminals.parameters.field.forceSignature': 'Force Signature',
  'terminals.parameters.field.enableDebitAids': 'Enable Debit AIDs',
  'terminals.parameters.field.enableGoCheckIn': 'Enable Go CheckIn',
  'terminals.parameters.field.enableUnreferencedRefund':
    'Enable Unreferenced Refund',
  'terminals.parameters.field.enableVoidInHomeScreen':
    'Enable Void In Home Screen',
  'terminals.parameters.action.save': 'Save Parameters',
  'terminals.parameters.toast.loadFailed': 'Failed to load terminal config',
  'terminals.parameters.toast.updated': 'Config updated',
  'terminals.parameters.toast.updateFailed': 'Failed to update config',
};
